import { useGetAllReportingManagers } from '@/hooks/data/masterDataHook';
import { Select, SelectProps } from 'antd';
import React from 'react';

interface Props extends SelectProps<any> {}
export default function ReportingManagersInput({ ...props }: Props) {
  const { data, isLoading } = useGetAllReportingManagers();

  return (
    <Select
      maxTagCount="responsive"
      allowClear
      loading={isLoading}
      {...props}
      filterOption={(input, option) => {
        return (option?.children as any)?.toLowerCase().includes(input.toLowerCase());
      }}
      showSearch={true}
    >
      {data?.data?.map(c => {
        return (
          <Select.Option key={c.id} value={c.id}>
            {`${c.firstName} ${c.lastName}`}
          </Select.Option>
        );
      })}
    </Select>
  );
}
